import { render, staticRenderFns } from "./GoldVariable.vue?vue&type=template&id=1232e4d6"
import script from "./GoldVariable.vue?vue&type=script&lang=js"
export * from "./GoldVariable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports